import { formatMmSs, formatRestDuration } from "../utils/format";

// 一個受試者在單一曲目上的聆聽進度條：綠色填滿代表已播放進度，圓點標記每次暫停的
// 位置（休息超過 15 分鐘的暫停用較大的橘色圓點區分），未完成時用紅色斜紋填滿樣式。
// 依單曲分析（多位受試者各一條）跟依受試者分析（單一受試者一條）共用同一份樣式。
// 用到的 class name（ef-progress-*）定義在 pages/EventFunnelPage.css，
// 這個元件目前只有事件漏斗頁面在用。
const LONG_PAUSE_THRESHOLD_SEC = 900; // 15 分鐘，跟後端依從性異常判斷的門檻一致

export default function ProgressBar({ completionPct, pauses, songDurationSec }) {
  const pct = completionPct != null ? Math.min(100, Math.max(0, completionPct)) : 0;
  return (
    <div className="ef-progress-track">
      <div
        className={`ef-progress-fill ${pct < 100 ? "incomplete" : ""}`}
        style={{ width: `${pct}%` }}
      />
      {(pauses || []).map((p, idx) => {
        const left = songDurationSec
          ? Math.min(100, ((p.position_sec || 0) / songDurationSec) * 100)
          : 0;
        const isLong = (p.rest_duration_sec || 0) > LONG_PAUSE_THRESHOLD_SEC;
        return (
          <div
            key={idx}
            className={`ef-progress-pin ${isLong ? "long" : ""}`}
            style={{ left: `${left}%` }}
            tabIndex={0}
            data-tip={`位置 ${formatMmSs(p.position_sec)}・${formatRestDuration(p.rest_duration_sec)}`}
          />
        );
      })}
    </div>
  );
}
